/** @jsx jsx */
import React from 'react'
import { Box, jsx } from 'theme-ui'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { CustomCard } from './shared/WidgetContainer'

const ContentCard = styled(CustomCard)`
  a {
    display: flex;
    flex-flow: ${({ listStyle }) => (listStyle ? 'row' : 'column')};
    flex-wrap: wrap;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    color: ${(props) => props.theme.colors.text};
    text-decoration: none;
    }
  }
`

const StyledImg = styled(GatsbyImage)`
  border-top-left-radius: 10px;
  border-top-right-radius: ${({ listStyle }) => (listStyle ? '0px' : '10px')};
  border-bottom-left-radius: ${({ listStyle }) => (listStyle ? '10px' : '0px')};
  img {
    border-top-left-radius: 10px;
    border-top-right-radius: ${({ listStyle }) => (listStyle ? '0px' : '10px')};
    border-bottom-left-radius: ${({ listStyle }) =>
      listStyle ? '10px' : '0px'};
  }
`

const Title = styled.h2`
  font-size: 1.5em;
  font-weight: 600;
  text-transform: capitalize;
  margin: 1rem 1rem 0.5rem 1rem;
`

const Date = styled.h3`
  margin: 0 1rem 0.5rem 1rem;
  color: gray;
`

const ReadingTime = styled.h4`
  margin: 0 1rem 1.5rem 1rem;
  color: gray;
`

const Excerpt = styled.p`
  margin: 0 1rem 1rem 1rem;
  line-height: 1.6;
`

const Card = ({
  slug,
  heroImage,
  title,
  publishDate,
  description,
  body,
  subtitle,
  listStyle,
  imageHeight,
  overline,
  ...props
}) => {
  const descript = description?.description || body?.childMarkdownRemark
  const subT = subtitle
    ? subtitle
    : body?.childMarkdownRemark.timeToRead &&
      `${body.childMarkdownRemark.timeToRead} min read`

  return (
    <>
      {heroImage && (
        <ContentCard
          flush={true}
          featured={props.featured}
          listStyle={listStyle}
        >
          <Link
            to={props.basePath ? `/${props.basePath}/${slug}/` : `/${slug}`}
          >
            <StyledImg
              image={heroImage.gatsbyImageData}
              backgroundColor={'#eeeeee'}
              objectFit={listStyle && 'cover'}
              alt={`Card image for ${title}`}
              {...props}
              sx={{
                minHeight: imageHeight,
                maxHeight: imageHeight,
                maxWidth: listStyle && ['100%', null, '40%'],
              }}
            />
            <Box sx={{ width: listStyle ? ['100%', null, '60%'] : '100%' }}>
              <Title>{title}</Title>
              {subT && <ReadingTime>{subT}</ReadingTime>}
              {descript && (
                <Excerpt
                  dangerouslySetInnerHTML={{
                    __html: descript.excerpt || descript,
                  }}
                />
              )}
            </Box>
          </Link>
        </ContentCard>
      )}
    </>
  )
}

export default Card
